module.exports = {"header":"Som kunde hos Deveo vil det snart være muligt at logge ind og administrere din løsning.","text":"Vi er dog ikke helt klar endnu, men hold dig opdateret på vores Facebookside.","button":"Gå tilbage til hovedsiden","meta":{"title":"Deveo | Log ind","description":"Som kunde hos Deveo vil det snart være muligt at logge ind og administrere din løsning."}}


//////////////////
// WEBPACK FOOTER
// ./src/app/login/lang/da.lang.json
// module id = 343
// module chunks = 1